module.exports = __webpack_public_path__ + "img/img2.15ec96e6.svg";